export enum HelpFormRoutingEnum {
  Player = 'form',
  PlayerEdition = 'form/:questionId',
  Summary = 'summary',
  EndEligibility = 'end-eligibility',
}
